"use strict";

var BillingAddressSelectionTypes = require("../designer/Constants").BILLING_ADDRESS_SELECTION_TYPES;

var AccountFormHelper = require("./AccountFormHelper");
var DefaultBillingAndShippingAddressHelper = require("./DefaultBillingAndShippingAddressHelper");

var BillingAddressHelper = {
	initialize: function (options) {
		options = options || {};

		if (options.defaultBillingAddressType) {
			// Save the default so that it can be used later by MyRecurringRefresh and MySubscriptionsRefresh.
			this.defaultBillingAddressType = options.defaultBillingAddressType;

			// On page load, we have to wait for react components to finish loading before we can set default options.
			document.addEventListener("DOMContentLoaded", () => {
				this.selectDefaultBillingAddressTypes();
				this.initializeAddressFormListeners();
			});
		}

		// 'billingAddressAddFormSelector' is set by MyRecurringRefresh and MySubscriptionsRefresh.
		// In these cases, the DOMContentLoaded event will not be fired, and the address type selector must be set manually.
		// The selector is provided to limit the scope of initialization to the new form being added to the page.
		if (options.billingAddressAddFormSelector) {
			this.selectDefaultBillingAddressTypes(options.billingAddressAddFormSelector);
		}

		var $billingAddressSelectors = $("select[data-component='billingAddress.selector.select']");

		$billingAddressSelectors.off("change");
		$billingAddressSelectors.change((event) => {
			this.handleAddressSelection(event);
		});

		// We may need to show the Add Form initially if the New Address Option is selected by default.
		$billingAddressSelectors.trigger("change");
	},

	initializeAddressFormListeners: function () {
		this.setAddressInputListeners('[data-component="createAccountAndCheckout"] #createAccountForm');
		this.setAddressInputListeners('[data-component="shipToOtherAddresses"] #addOtherAddresses');
	},

	setAddressInputListeners: function ($formSelector) {
		var addressInputSelectors = [
			$(`${$formSelector} input[data-component='accountAddressLine1']`),
			$(`${$formSelector} input[data-component='accountAddressLine2']`),
			$(`${$formSelector} input[data-component='accountAddressLine3']`),
			$(`${$formSelector} input[data-component='accountAddressLine4']`),
			$(`${$formSelector} input[data-component='accountAddressCity']`),
			$(`${$formSelector} select[name='address.country']`),
			$(`${$formSelector} input[data-component='accountAddressPostalCode']`),
			$(`${$formSelector} [data-shared-name='address.state.field']`),
			$(`${$formSelector} select[name='address.state']`),
			$(`${$formSelector} input[name='address.state']`),
			$(`${$formSelector} input[data-component='accountAddressDefaultBillingCheckbox.input']`),
			$(`${$formSelector} input[data-component='accountAddressDefaultShippingCheckbox.input']`)
		];

		addressInputSelectors.forEach($selector => {
			$selector.on("change", () => {
				this.updateNewAddressInSelector($formSelector);
			});
		});
	},

	selectDefaultBillingAddressTypes: function ($parentSelector) {
		$parentSelector = $parentSelector || $('[data-component="billingAddress.addForm"]');
		$parentSelector.find(`select[name="address.type"] option[value="${this.defaultBillingAddressType}"]`)
			.prop("selected", true);
	},

	handleShowOtherAddresses: function ($otherAddresses) {
		$otherAddresses = $($otherAddresses);
		var $addFormSelectOption = $otherAddresses.find("[data-component='otherAddresses.addForm'] input[type='radio'][name='otherAddressesSelector']");
		if ($addFormSelectOption.prop("checked") === true) {
			var $formSelector = $otherAddresses.find("[data-component='otherAddresses.addForm'] #addOtherAddresses");
			this.updateNewAddressInSelector($formSelector);
		}
	},

	handleAddressSelection: function (event) {
		if (!event || !event.target || event.type !== "change") {
			return false;
		}

		var $billingAddress = $(event.target).closest('[data-component="billingAddress"]');
		var $selector = $billingAddress.find('[data-component="billingAddress.selector"]');
		var $options = $selector.find("option");
		var $addForm = $billingAddress.find('[data-component="billingAddress.addForm"]');

		if ($billingAddress.length <= 0 || $selector.length <= 0 || $addForm.length <= 0) {
			return false;
		}

		// If the selector has no options, show the add form, and hide the selector from the page.
		if (!$options.length) {
			$addForm.removeClass("hidden");
			$selector.addClass("hidden");
			$billingAddress.attr("data-current-component", "billingAddress.addForm");
		}

		$selector.attr("data-is-auto-selection-restricted", "true");
		var $selectedOption = $selector.find("option:selected");

		if ($selectedOption.length === 1) {
			if ($selectedOption.html() === $selector.attr('data-new-address-text')) {
				$addForm.removeClass("hidden");
				$billingAddress.attr("data-current-component", "billingAddress.addForm");
			} else {
				$addForm.addClass("hidden");
				$billingAddress.attr("data-current-component", "billingAddress.selector");
			}
		}
	},

	getBillingAddressInformation: function ($paymentTypeComponent) {
		var selectionType = BillingAddressSelectionTypes.DEFAULT;
		var address = {};

		var $billingAddress = $paymentTypeComponent.find("[data-component='billingAddress']");
		if ($billingAddress.length) {
			var $selectedOption = $paymentTypeComponent.find("[data-component='billingAddress.selector'] option:selected");

			selectionType = (
				($selectedOption.length === 0 && BillingAddressSelectionTypes.NEW) ||
				($selectedOption.attr("data-is-new-address-option") && BillingAddressSelectionTypes.NEW) ||
				($selectedOption.attr("data-is-primary-placeholder-option") && BillingAddressSelectionTypes.NEW_PRIMARY) ||
				($selectedOption.attr("data-is-ship-to-placeholder-option") && BillingAddressSelectionTypes.NEW_SHIPPING) ||
				BillingAddressSelectionTypes.EXISTING
			);

			if (selectionType === BillingAddressSelectionTypes.NEW) {
				var $addForm = $billingAddress.find("[data-component='billingAddress.addForm']");
				var addFormData = AccountFormHelper.serializeAddressForm($addForm.find("form"));
				address = addFormData.address;
				address.type = $addForm.find("select[name='address.type'] option:selected").val();
			}

			address.id = $selectedOption.val();
		}

		return {
			selectionType,
			address
		};
	},

	removeNewShippingAddressOptionFromSelector: function () {
		this.removeOptionFromSelector($('option[data-is-ship-to-placeholder-option]'));
	},

	removeExistingAddressOptionFromSelector: function (addressId) {
		this.removeOptionFromSelector($(`option[value="${addressId}"]`));
	},

	removeOptionFromSelector: function ($optionSelector) {
		$('[data-component="billingAddress.selector"]').each((index, element) => {
			var $billingAddressSelector = $(element);
			var $optionToDelete = $billingAddressSelector.find($optionSelector);

			if ($optionToDelete.is(':selected')) {
				var $defaultBillingOption = $billingAddressSelector.find('option[data-is-default-billing="true"]');
				if (!$defaultBillingOption.length) {
					$defaultBillingOption = $billingAddressSelector.find('option[data-is-primary="true"]');
				}

				$defaultBillingOption.prop("selected", true);
			}

			$optionToDelete.remove();
		});
	},

	updateEditedAddressInSelector: function (addressId, addressData) {
		$('[data-component="billingAddress.selector"]').each((index, element) => {
			var $billingAddressSelector = $(element);
			var formattedAddress = this.generateFormattedAddress($billingAddressSelector, addressData);

			// update the edited options
			var $editedAddressOption = $billingAddressSelector.find(`option[value="${addressId}"]`);
			$editedAddressOption.text(formattedAddress);
			this.updateOptionAddressDataAttributes($editedAddressOption, addressData);
		});
	},

	updateNewAddressInSelector: function (addressFormSelector) {
		var $addressForm = $(addressFormSelector);
		var addressData = AccountFormHelper.serializeAddressForm($addressForm);

		if (!$('[data-component="createAccountAndCheckout"]').length) {
			DefaultBillingAndShippingAddressHelper.serializeCheckboxes($addressForm, addressData);
		}

		var isNewShippingAddress = $addressForm.closest('[data-component="shipToOtherAddresses"]').length;
		var isNewPrimaryAddress = $addressForm.closest('[data-component="createAccountAndCheckout"]').length;

		// Make sure we update all billing address selectors according to their own formats
		$('[data-component="billingAddress.selector"]').each((index, element) => {
			var $billingAddressSelector = $(element);
			var formattedAddress = this.generateFormattedAddress($billingAddressSelector, addressData);
			var shouldAutoSelectDefaultBillingOption = !$billingAddressSelector.attr("data-is-auto-selection-restricted");

			// choose the new primary address option by default
			var $optionToUpdate = isNewPrimaryAddress && $billingAddressSelector.find("option[data-is-primary-placeholder-option]") || $(null);

			if (isNewShippingAddress) {
				var $optionToUpdate = $billingAddressSelector.find("option[data-is-ship-to-placeholder-option]");
				if (!$optionToUpdate.length) {
					// Add the new option right above the new address option.
					var $newAddressOption = $billingAddressSelector.find("option[data-is-new-address-option]");
					$newAddressOption.before($('<option data-is-ship-to-placeholder-option="true"></option>').val("0"));

					$optionToUpdate = $billingAddressSelector.find('option[data-is-ship-to-placeholder-option]');
				}
			}

			if ($optionToUpdate.length) {
				// Now that the option is in place, we can update the formatted address description.
				$optionToUpdate.text(formattedAddress);
				this.updateOptionAddressDataAttributes($optionToUpdate, addressData);
				if (shouldAutoSelectDefaultBillingOption) {
					$billingAddressSelector.find('option[data-is-default-billing="true"]').prop("selected", true);
				}
			}
		});
	},

	updateOptionAddressDataAttributes: function ($option, addressFormData) {
		var address = (addressFormData || {}).address || {};
		$option.attr("data-is-primary", address.isPrimary ? "true" : "false");
		$option.attr("data-line1", address.line1);
		$option.attr("data-line2", address.line2);
		$option.attr("data-line3", address.line3);
		$option.attr("data-line4", address.line4);
		$option.attr("data-city", address.city);
		$option.attr("data-state", address.state);
		$option.attr("data-postal-code", address.postalCode);
		$option.attr("data-country", address.country);
		$option.attr("data-is-default-billing", address.isDefaultBilling ? "true" : "false");
		$option.attr("data-is-default-shipping", address.isDefaultShipping ? "true" : "false");
		$option.attr("data-type", address.type);
	},

	generateFormattedAddress: function ($billingAddressSelector, addressFormData) {
		var address = (addressFormData || {}).address || {};
		var formatOptions = this.getFormatOptions($billingAddressSelector);
		var addressFormat = formatOptions.addressFormat;
		var separator = formatOptions.separator;
		var defaultBillingDesignation = formatOptions.defaultBillingDesignation;

		// All address formats start with Line 1.
		var formattedAddress = address.line1;

		if (addressFormat.includes("Line 2") && address.line2) {
			formattedAddress += `${separator}${address.line2}`;
		}

		if (addressFormat.includes("City") && address.city) {
			formattedAddress += `${separator}${address.city}`;
		}

		if (addressFormat.includes("State") && address.state) {
			formattedAddress += `${separator}${address.state}`;
		}

		if (addressFormat.includes("Postal Code") && address.postalCode) {
			formattedAddress += `${separator}${address.postalCode}`;
		}

		if (addressFormat.includes("Country") && address.country) {
			formattedAddress += `${separator}${address.country}`;
		}

		if (defaultBillingDesignation && address.isDefaultBilling) {
			if (formatOptions.defaultBillingDesignationPosition == "Beginning") {
				formattedAddress = `${defaultBillingDesignation}${formattedAddress}`;
			}
			else {
				formattedAddress = `${formattedAddress}${defaultBillingDesignation}`;
			}
		}

		return formattedAddress;
	},

	getFormatOptions: function ($billingAddressSelector) {
		$billingAddressSelector = $($billingAddressSelector) || $(null);

		return {
			addressFormat: $billingAddressSelector.attr("data-address-format"),
			separator: $billingAddressSelector.attr("data-separator"),
			defaultBillingDesignationPosition: $billingAddressSelector.attr("data-default-billing-designation-position"),
			defaultBillingDesignation: $billingAddressSelector.attr("data-default-billing-designation"),
		};
	}
};

module.exports = BillingAddressHelper;



// WEBPACK FOOTER //
// ./Javascript/accountComponents/BillingAddressHelper.jsx